import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    getCustomerGrouping: {
        url: `${customerApi}/api/customer_group`,
        type: 'GET',
    },
    getGroupGrouping: {
        url: `${customerApi}/api/group_chat_category`,
        type: 'GET',
    },
}
